import { useStorage } from 'hooks'
import { createContext, Dispatch, SetStateAction } from 'react'
import jwtDecode from 'jwt-decode'

interface AuthContextType {
  setToken: Dispatch<SetStateAction<string>>
  token: string
  signin: (_newToken: string, _callback: VoidFunction) => void
  signout: (_callback: VoidFunction) => void
  setFirstToken: (_newToken: string) => void
  user: {
    isAdmin: boolean
    isLogged: boolean
    user: {
      cellphone: string
      id: number
      level: string
      nickname: string
    }
  }
}

interface IdecodedUser {
  payload: {
    isAdmin: boolean
    isLogged: boolean
    user: {
      cellphone: string
      id: number
      level: string
      nickname: string
    }
  }
}

export const AuthContext = createContext<AuthContextType>(null!)

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [token, setToken] = useStorage('SapiensToken')
  const [user, setUser] = useStorage('SapiensUser')

  const signin = (newToken: any, callback: VoidFunction) => {
    const decodedUser: IdecodedUser = jwtDecode(newToken)
    setUser(decodedUser.payload)
    callback()
  }

  const signout = (callback: VoidFunction) => {
    setToken(null)
    setUser(null)
    callback()
  }

  const setFirstToken = (newToken: any) => {
    const decodedUser: IdecodedUser = jwtDecode(newToken)
    setUser(decodedUser.payload)
  }

  const value = {
    token,
    setToken,
    signin,
    signout,
    user,
    setFirstToken,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
